export const getUserId = ({ sharedReducer: { userData }, signInReducer: { userId } }: any) =>
	userData.id || userId;
